export const passport = {
    getMessage: field => 'Значение ' + field + ' должно быть корректным паспортом.',
    validate: (value, []) => {
        if (!value) return false;
        value = value.replace(/\D/g, "");
        let length = (value.length == 10);
        if (!length) return length;

        let year = value.substring(2, 4),
            number = value.substring(4),
            currentYear = new Date().getFullYear().toString().substring(2, 4);

        if (parseInt(number) < 101 || parseInt(number) > 999999) return false;
        
        if ((parseInt(year) >= 97 && parseInt(year) <= 99) || (parseInt(year) >= 0 && parseInt(year) <= parseInt(currentYear))) return true;
        else return false;
    }
}

export const dateBefore = {
    getMessage: (field, [target]) => `Дата ${field} должна быть до ${target}`,
    validate(value, [target]) {
        if (!value || !target) return true
        return new Date(value).getTime() < new Date(target).getTime()
    }
}

export default (validator) => {
    validator.extend('passport', passport);
    validator.extend('dateBefore', dateBefore);

    return validator;
}


// WEBPACK FOOTER //
// ./src/helpers/rules/index.js